import React, { FunctionComponent } from 'react';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { propOr } from 'ramda';

import Query from 'scenes/Report/components/Query';
import ReportBase, { ReportParams } from 'scenes/Report/components/ReportBase';

import PerformanceOverviewChart from '../components/PerformanceOverviewChart';
import { GET_PERFORMANCE_OVERVIEW } from '../PerformanceOverview.queries';
import { MerchantTransactionTotals } from '../PerformanceOverview.helper';

type Props = {
  extraClasses?: {
    batchMode?: boolean;
  };
};

type QueryResponse = {
  merchantTransactionTotals?: MerchantTransactionTotals[];
};

const generateChart = (
  merchantTransactionTotals: MerchantTransactionTotals,
  index: number,
  extraClasses: Record<string, unknown>,
): JSX.Element => (
  <PerformanceOverviewChart
    merchantTransactionTotals={merchantTransactionTotals}
    extraClasses={extraClasses}
    key={index}
  />
);

const renderReport = (
  params: ReportParams,
  header: string,
  { extraClasses = {} }: Props,
) => (response: QueryResponse = {}): JSX.Element => {
  const totals = propOr(
    [],
    'merchantTransactionTotals',
    response,
  ) as MerchantTransactionTotals[];

  return (
    <ReportBase
      batchKey="performanceOverview"
      header={header}
      params={params}
      batchData={totals}
    >
      <>
        {totals.map((transactionTotal, index) =>
          generateChart(transactionTotal, index, extraClasses),
        )}
      </>
    </ReportBase>
  );
};

const header = 'Performance Overview';

const PerformanceOverview: FunctionComponent<Props> = (props) => {
  const location = useLocation();
  const params = queryString.parse(location.search) as ReportParams;

  return (
    <Query
      query={GET_PERFORMANCE_OVERVIEW}
      reportName={header}
      batchKey="performanceOverview"
      variables={{ params }}
      render={renderReport(params, header, props)}
    />
  );
};

export default PerformanceOverview;
